import "./Feature.css";

const features = [
  {
    icon: "🤖",
    iconBg: "rgba(232, 98, 26, 0.1)",
    title: "AI Automation (WhatsApp + QR Integration)",
    description:
      "Automate messages, responses, and follow-ups across WhatsApp and QR codes effortlessly. Handle thousands of conversations instantly, even while you sleep.",
    cta: "Scale your Business with AI",
  },
  {
    icon: "📲",
    iconBg: "rgba(42, 171, 204, 0.1)",
    title: "NFC Cards",
    description:
      "Tap to share your full digital profile instantly. Works with any phone; iPhone or Android, no app needed.",
    cta: "Never lose a contact again",
  },
  {
    icon: "🛍️",
    iconBg: "rgb(232, 253, 240)",
    title: "E-Commerce Store",
    description:
      "Launch your own branded online store in minutes. Sell products, manage inventory, and accept payments with ease.",
    cta: "Sell 24/7 with zero commissions",
  },
  {
    icon: "🍽️",
    iconBg: "rgba(232, 98, 26, 0.1)",
    title: "Food Ordering App",
    description:
      "Your own restaurant app accepts orders and payments directly. Fully branded, simple, and commission-free for your business.",
    cta: "Keep 100% of every order",
  },
  {
    icon: "🏘️",
    iconBg: "rgba(245, 200, 66, 0.1)",
    title: "Real Estate Listings",
    description:
      "Showcase properties with photos, videos, and rich details in your personalized app. Let clients browse and book instantly.",
    cta: "Close deals 3× faster",
  },
  {
    icon: "📊",
    iconBg: "rgba(42, 171, 204, 0.1)",
    title: "Analytics Dashboard",
    description:
      "Track leads, sales, clicks, and revenue all in one place. Make data-driven decisions with ease.",
    cta: "See results, grow with confidence",
  },
];

export default function Feature() {
  return (
    <div id="features" className="platform-wrapper mainclass">
      <div className="platform-inner maxwidth">
        <div className="platform-header">
          <p className="platform-label">PLATFORM FEATURES</p>
          <h1 className="platform-title heading">
           One Platform for All Your Business Needs: Starting at Just ₹999

          </h1>
          <p className="platform-subtitle">
            Get all your business tools; AI, dashboards, NFC cards, no-code apps, and more, bundled into one platform that saves you time, money, and effort.

          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, i) => (
            <div key={i} className="feature-card">
              <div
                className="feature-icon-wrap"
                style={{ backgroundColor: feature.iconBg }}
              >
                {feature.icon}
              </div>

              <h3 className="feature-title">{feature.title}</h3>

              <p className="feature-description">{feature.description}</p>

              <div className="feature-cta">
                <span>{feature.cta}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
